import { NAME } from './constants';
import { apiProvider } from './api';
import { router } from './router';

export const NdSkladPreceneni = {
	name: NAME,
	apiProvider,
	router,
};
